import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { Observable } from "rxjs";
import { ResponsePropietarioFisica } from "../pojos/responsePropietarioFisica";

@Injectable({
    providedIn: 'root'
})
export class ConfirmarInformacionPropietario {

    private endPoint: string = `${environment.HOST}/confirmarInformacionPropietarioFisica`

    constructor(private http: HttpClient){

    }

    confirmarInformacionPropietario(strRfcIngresado:string, strRfcEncontrado:string, strCurp:string): Observable<ResponsePropietarioFisica> {
        const params = new HttpParams()
        .set('strRfcIngresado',strRfcIngresado)
        .set('strRfcEncontrado',strRfcEncontrado)
        .set('strCurp',strCurp)
        return this.http.get<ResponsePropietarioFisica>(this.endPoint, {params});
    }
}